export default __webpack_public_path__ + "static/media/d1fa05c7755fd60b.213746c0f463016df87189dc85c503f6.svg";